export default __webpack_public_path__ + "static/media/50 inex_02.f30d14b7.png";